/**
 * SkeletonRow primitive — uniform loading placeholder matching the height of real content.
 * Uses Tailwind design tokens — no hardcoded hex colors.
 */
import React from 'react';

export interface SkeletonRowProps {
  count?: number;
  width?: string;
}

export function SkeletonRow({ count = 1, width }: SkeletonRowProps): React.ReactElement {
  return (
    <div role="presentation" className="animate-pulse space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex items-center space-x-4">
          <div className="rounded-full bg-gray-300 dark:bg-gray-700 h-12 w-12" />
          <div className="flex-1 space-y-2">
            <div
              className="h-4 bg-gray-300 dark:bg-gray-700 rounded"
              style={{ width: width ?? '60%' }}
            />
            <div className="h-3 bg-gray-300 dark:bg-gray-700 rounded w-3/4" />
          </div>
        </div>
      ))}
    </div>
  );
}
